import React from 'react'

export default ({ src, className, alt, defaultSrc = '//cdn.jsdelivr.net/npm/@clina_z/cotalk/src/assets/icon/codeberg.svg' }) => (
  <div className={`gt-avatar ${className}`}>
    <img src={src || defaultSrc} alt={`@${alt}`} onError={function (e) {
      e.target.src = defaultSrc
    }} />
  </div>
)
